import * as React from 'react';
import { Responsive, UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface INewAnswerProps {
  userInfo: React.ReactNode | null;
  answer: React.ReactElement;
  anonymous: React.ReactElement | null;
  error?: string;
}

export const NewAnswer = ({ userInfo, answer, anonymous, error }: React.PropsWithChildren<INewAnswerProps>) => {
  return (
    <div className={styles['content']}>
      {userInfo && (
        <div className={styles['section']}>
          <div className={styles['title']}>
            <UIHeading4>Расскажите о себе</UIHeading4>
          </div>
          {userInfo}
        </div>
      )}
      <div className={styles['section']}>{answer}</div>
      {anonymous && <div className={styles['section']}>{anonymous}</div>}
      <Responsive phone tablet>
        {error && (
          <div className={styles['error']}>
            <UIText2 color="white_100">{error}</UIText2>
          </div>
        )}
      </Responsive>
    </div>
  );
};
